/**
 * created by Alex Xia on 25/06/19
 * Description:
 */
import { Subject } from 'rxjs';

import { Contact } from '../../tamalelibs/models/contact.model';

export class ContactDetailConfig {
    // data
    embedMode: boolean;
    isSideSheet: boolean;
    contact: Contact;
    actions$?: Subject<any>;

    constructor() {
        this.actions$ = new Subject<any>();
    }
}
